import React from 'react'

import { Switch } from '@/components/Switch'
import ReadableStringUtils from '../utils/ReadableStringUtils'
import { Meal, MealOfDay, MealOfDayDivision } from '@/api/types'
import { Grid } from '@/components/Grid'
import { SORTED_MEALS } from '../constants'

import './MealPreferencesControl.css'
import SelectedMealDivisions, { GenerateMealDivisionIdFn } from './SelectedMealDivisions'

export type MealPreferencesControlOnChangeFn = (
  selectedMeals: Meal[],
  mealOfDayDivisions: MealOfDayDivision[],
) => void

export type GenerateMealPreferencesControlFn = (selectedMeals: Meal[]) => void

type Props = {
  selectedMeals: Meal[]
  isReadonly?: boolean
  mealOfDayDivisions: MealOfDayDivision[]
  onChange?: MealPreferencesControlOnChangeFn
  generateMealDivisionId?: GenerateMealDivisionIdFn
}

export default function MealPreferencesControl({
  selectedMeals,
  isReadonly = false,
  mealOfDayDivisions,
  onChange,
  generateMealDivisionId,
}: Props) {
  const sortedSelectedMeals = SORTED_MEALS.filter((mealOfDay) =>
    selectedMeals.some((sm) => sm.mealOfDay === mealOfDay),
  )

  function handleChangeSelectedMeal(mealOfDay: MealOfDay, value: boolean) {
    if (value) {
      const selected = [...selectedMeals, { mealOfDay }].sort(
        (a, b) => SORTED_MEALS.indexOf(a.mealOfDay) - SORTED_MEALS.indexOf(b.mealOfDay),
      )
      !isReadonly && onChange?.(selected, mealOfDayDivisions)
    } else {
      !isReadonly &&
        onChange?.(
          selectedMeals.filter((sm) => sm.mealOfDay !== mealOfDay),
          mealOfDayDivisions.filter((mod) => mod.mealOfDay !== mealOfDay),
        )
    }
  }

  function onChangeMealOfDayDivision(mealOfDayDivisions: MealOfDayDivision[]) {
    !isReadonly && onChange?.(selectedMeals, mealOfDayDivisions)
  }

  return (
    <Grid columns="2fr 5fr">
      <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
        {SORTED_MEALS.map((mealOfDay) => (
          <Switch
            key={mealOfDay}
            isReadOnly={isReadonly}
            isSelected={selectedMeals.some((sm) => sm.mealOfDay === mealOfDay)}
            onChange={(value) => handleChangeSelectedMeal(mealOfDay, value)}>
            {ReadableStringUtils.readableMealOfDay(mealOfDay)}
          </Switch>
        ))}
      </div>
      <SelectedMealDivisions
        style={{ width: '760px' }}
        isReadOnly={isReadonly}
        mealsOfDay={sortedSelectedMeals}
        onChange={onChangeMealOfDayDivision}
        mealOfDayDivisions={mealOfDayDivisions}
        generateMealDivisionId={generateMealDivisionId}
      />
    </Grid>
  )
}
